module.exports = __webpack_public_path__ + "img/login_bg.958e7941.jpg";